var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductTog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.817,
    height: 16.817,
    viewBox: "0 0 16.817 16.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product-_tog",
    "data-name": "Product- tog",
    transform: "translate(-247 -160.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "inventory_2_FILL0_wght400_GRAD0_opsz48",
    d: "M4.841,19.514V9.171a.9.9,0,0,1-.568-.42A1.372,1.372,0,0,1,4,7.931V5.261a1.222,1.222,0,0,1,.378-.872A1.2,1.2,0,0,1,5.261,4H19.556a1.206,1.206,0,0,1,.872.389,1.206,1.206,0,0,1,.389.872v2.67a1.372,1.372,0,0,1-.273.82.9.9,0,0,1-.568.42V19.514a1.276,1.276,0,0,1-.389.893,1.179,1.179,0,0,1-.872.41H6.1a1.167,1.167,0,0,1-.883-.41A1.293,1.293,0,0,1,4.841,19.514ZM6.1,9.192V19.556H18.715V9.192ZM19.556,7.931V5.261H5.261v2.67Zm-9.67,5.676h5.045V12.346H9.886ZM6.1,19.556v0Z",
    transform: "translate(243 156.302)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductTog);
export default __webpack_public_path__ + "static/media/product_tog.dbf8e0bf38e01b9a43c8caaa3c908bcf.svg";
export { ForwardRef as ReactComponent };